import { ButtonPresentationProps } from "@insite/mobius/Button";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { formNarrowGridProps } from "@store/theme/common/props/form";

export interface StoreHistoryFilterProps {
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
    subGridItem?: GridItemProps;
    applyButton?: ButtonPresentationProps;
    clearButton?: ButtonPresentationProps;
}

export const historyFilterProps: StoreHistoryFilterProps = {
    gridContainer: formNarrowGridProps,
    gridItem: { width: [12, 12, 12, 6, 4] },
    subGridItem: { width: [6, 6, 6, 3, 2] },
    applyButton: {
        variant: "primary",
    },
    clearButton: {
        variant: "secondary",
    },
};
